/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error-view[_ngcontent-%COMP%]{text-align:center;padding:20px}h2[_ngcontent-%COMP%]{color:#f03241;padding-bottom:20px;font-size:2.5em;font-weight:700}p[_ngcontent-%COMP%]{margin-top:20px;padding-bottom:10px;font-size:.9em;line-height:1.5em}"];
export { styles as styles };
